import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import SEO from './SEO';
import Navigation from './Navigation';

function BrandPage() {
  const { brand } = useParams();
  const navigate = useNavigate();

  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Brand data with specific information for each manufacturer
  const brandData = {
    toyota: {
      name: 'Toyota',
      logo: 'toyota.png',
      description: 'In need of a key for your Toyota? Carkey Solutions are your answer. Whether your keys have been lost/stolen, or you require a spare. Carkey Solutions have you covered.',
      features: [
        'Carkey Solutions is Perth\'s leading Automotive Locksmiths. All our work is guaranteed and we have the specialist knowledge and equipment to offer the safest processes for programming keys to your car.',
        'We offer a full onsite mobile service, there is no need to tow your car. We service the Perth & surrounding areas free of charge so there\'s no need to run around wasting your time when Carkey Solutions can come to you while you get on with your busy day.',
        'All keys are cut onsite on our computerised key cutter. We don\'t simply copy keys from old ones and supply you with a substandard key. Our specialist equipment allows us to cut keys to the original factory code on a new genuine or aftermarket key. This process saves money in the long run by decreasing wear on your ignition and door locks.',
        'Carkey Solutions can offer the most cost effective options with less waiting time than the dealership and in most cases better quality keys than the genuine equivalent. We stock a large range of genuine and aftermarket key solutions for Toyota\'s.',
        'Locked out? We offer the safest opening methods in Perth and guarantee we won\'t damage your car.'
      ],
      services: [
        'Replacement Keys',
        'Spare Keys',
        'Immobiliser ECU Resetting',
        'Opening Service',
        'Repair / Replace Locks',
        'Re-key Existing Locks',
        'We stock a large range of Genuine / Aftermarket keys'
      ]
    },
    honda: {
      name: 'Honda',
      logo: 'honda.png',
      description: 'In need of a key for your Honda? Carkey Solutions are your answer. Whether your keys have been lost/stolen, or you require a spare. Carkey Solutions have you covered.',
      features: [
        'Carkey Solutions is Perth\'s leading Automotive Locksmiths. All our work is guaranteed and we have the specialist knowledge and equipment to offer the safest processes for programming keys to your car.',
        'We offer a full onsite mobile service, there is no need to tow your car. We service the Perth & surrounding areas free of charge so there\'s no need to run around wasting your time when Carkey Solutions can come to you while you get on with your busy day.',
        'All keys are cut onsite on our computerised key cutter. We don\'t simply copy keys from old ones and supply you with a substandard key. Our specialist equipment allows us to cut keys to the original factory code on a new genuine or aftermarket key. This process saves money in the long run by decreasing wear on your ignition and door locks.',
        'Carkey Solutions can offer the most cost effective options with less waiting time than the dealership and in most cases better quality keys than the genuine equivalent. We stock a large range of genuine and aftermarket key solutions for Honda\'s.',
        'Locked out? We offer the safest opening methods in Perth and guarantee we won\'t damage your car.'
      ],
      services: [
        'Replacement Keys',
        'Spare Keys',
        'Immobiliser ECU Resetting',
        'Opening Service',
        'Repair / Replace Locks',
        'Re-key Existing Locks',
        'We stock a large range of Genuine / Aftermarket keys'
      ]
    },
    ford: {
      name: 'Ford',
      logo: 'ford.png',
      description: 'In need of a key for your Ford? Carkey Solutions are your answer. Whether your keys have been lost/stolen, or you require a spare. Carkey Solutions have you covered.',
      features: [
        'Carkey Solutions is Perth\'s leading Automotive Locksmiths. All our work is guaranteed and we have the specialist knowledge and equipment to offer the safest processes for programming keys to your car.',
        'We offer a full onsite mobile service, there is no need to tow your car. We service the Perth & surrounding areas free of charge so there\'s no need to run around wasting your time when Carkey Solutions can come to you while you get on with your busy day.',
        'All keys are cut onsite on our computerised key cutter. We don\'t simply copy keys from old ones and supply you with a substandard key. Our specialist equipment allows us to cut keys to the original factory code on a new genuine or aftermarket key. This process saves money in the long run by decreasing wear on your ignition and door locks.',
        'Carkey Solutions can offer the most cost effective options with less waiting time than the dealership and in most cases better quality keys than the genuine equivalent. We stock a large range of genuine and aftermarket key solutions for Ford\'s.',
        'Locked out? We offer the safest opening methods in Perth and guarantee we won\'t damage your car.'
      ],
      services: [
        'Replacement Keys',
        'Spare Keys',
        'Immobiliser ECU Resetting',
        'Opening Service',
        'Repair / Replace Locks',
        'Re-key Existing Locks',
        'We stock a large range of Genuine / Aftermarket keys'
      ]
    },
    bmw: {
      name: 'BMW',
      logo: 'bmw.png',
      description: 'In need of a key for your BMW? Carkey Solutions are your answer. Whether your keys have been lost/stolen, or you require a spare. Carkey Solutions have you covered.',
      features: [
        'Carkey Solutions is Perth\'s leading Automotive Locksmiths. All our work is guaranteed and we have the specialist knowledge and equipment to offer the safest processes for programming keys to your car.',
        'We offer a full onsite mobile service, there is no need to tow your car. We service the Perth & surrounding areas free of charge so there\'s no need to run around wasting your time when Carkey Solutions can come to you while you get on with your busy day.',
        'All keys are cut onsite on our computerised key cutter. We don\'t simply copy keys from old ones and supply you with a substandard key. Our specialist equipment allows us to cut keys to the original factory code on a new genuine or aftermarket key. This process saves money in the long run by decreasing wear on your ignition and door locks.',
        'Carkey Solutions can offer the most cost effective options with less waiting time than the dealership and in most cases better quality keys than the genuine equivalent. We stock a large range of genuine and aftermarket key solutions for BMW\'s.',
        'Locked out? We offer the safest opening methods in Perth and guarantee we won\'t damage your car.'
      ],
      services: [
        'Replacement Keys',
        'Spare Keys',
        'Immobiliser ECU Resetting',
        'Opening Service',
        'Repair / Replace Locks',
        'Re-key Existing Locks',
        'We stock a large range of Genuine / Aftermarket keys'
      ]
    },
    audi: {
      name: 'Audi',
      logo: 'audi.png',
      description: 'In need of a key for your Audi? Carkey Solutions are your answer. Whether your keys have been lost/stolen, or you require a spare. Carkey Solutions have you covered.',
      features: [
        'Carkey Solutions is Perth\'s leading Automotive Locksmiths. All our work is guaranteed and we have the specialist knowledge and equipment to offer the safest processes for programming keys to your car.',
        'We offer a full onsite mobile service, there is no need to tow your car. We service the Perth & surrounding areas free of charge so there\'s no need to run around wasting your time when Carkey Solutions can come to you while you get on with your busy day.',
        'All keys are cut onsite on our computerised key cutter. We don\'t simply copy keys from old ones and supply you with a substandard key. Our specialist equipment allows us to cut keys to the original factory code on a new genuine or aftermarket key. This process saves money in the long run by decreasing wear on your ignition and door locks.',
        'Carkey Solutions can offer the most cost effective options with less waiting time than the dealership and in most cases better quality keys than the genuine equivalent. We stock a large range of genuine and aftermarket key solutions for Audi\'s.',
        'Locked out? We offer the safest opening methods in Perth and guarantee we won\'t damage your car.'
      ],
      services: [
        'Replacement Keys',
        'Spare Keys',
        'Immobiliser ECU Resetting',
        'Opening Service',
        'Repair / Replace Locks',
        'Re-key Existing Locks',
        'We stock a large range of Genuine / Aftermarket keys'
      ]
    },
    mitsubishi: {
      name: 'Mitsubishi',
      logo: 'mitsubishi.png',
      description: 'In need of a key for your Mitsubishi? Carkey Solutions are your answer. Whether your keys have been lost/stolen, or you require a spare. Carkey Solutions have you covered.',
      features: [
        'Carkey Solutions is Perth\'s leading Automotive Locksmiths. All our work is guaranteed and we have the specialist knowledge and equipment to offer the safest processes for programming keys to your car.',
        'We offer a full onsite mobile service, there is no need to tow your car. We service the Perth & surrounding areas free of charge so there\'s no need to run around wasting your time when Carkey Solutions can come to you while you get on with your busy day.',
        'All keys are cut onsite on our computerised key cutter. We don\'t simply copy keys from old ones and supply you with a substandard key. Our specialist equipment allows us to cut keys to the original factory code on a new genuine or aftermarket key. This process saves money in the long run by decreasing wear on your ignition and door locks.',
        'Carkey Solutions can offer the most cost effective options with less waiting time than the dealership and in most cases better quality keys than the genuine equivalent. We stock a large range of genuine and aftermarket key solutions for Mitsubishi\'s.',
        'Locked out? We offer the safest opening methods in Perth and guarantee we won\'t damage your car.'
      ],
      services: [
        'Replacement Keys',
        'Spare Keys',
        'Immobiliser ECU Resetting',
        'Opening Service',
        'Repair / Replace Locks',
        'Re-key Existing Locks',
        'We stock a large range of Genuine / Aftermarket keys'
      ]
    }
  };

  // Default data for any brand not specifically defined
  const defaultData = {
    name: brand.charAt(0).toUpperCase() + brand.slice(1),
    logo: `${brand}.png`,
    description: `In need of a key for your ${brand.charAt(0).toUpperCase() + brand.slice(1)}? Carkey Solutions are your answer. Whether your keys have been lost/stolen, or you require a spare. Carkey Solutions have you covered.`,
    features: [
      'Carkey Solutions is Perth\'s leading Automotive Locksmiths. All our work is guaranteed and we have the specialist knowledge and equipment to offer the safest processes for programming keys to your car.',
      'We offer a full onsite mobile service, there is no need to tow your car. We service the Perth & surrounding areas free of charge so there\'s no need to run around wasting your time when Carkey Solutions can come to you while you get on with your busy day.',
      'All keys are cut onsite on our computerised key cutter. We don\'t simply copy keys from old ones and supply you with a substandard key. Our specialist equipment allows us to cut keys to the original factory code on a new genuine or aftermarket key. This process saves money in the long run by decreasing wear on your ignition and door locks.',
      `Carkey Solutions can offer the most cost effective options with less waiting time than the dealership and in most cases better quality keys than the genuine equivalent. We stock a large range of genuine and aftermarket key solutions for ${brand.charAt(0).toUpperCase() + brand.slice(1)}'s.`,
      'Locked out? We offer the safest opening methods in Perth and guarantee we won\'t damage your car.'
    ],
    services: [
      'Replacement Keys',
      'Spare Keys',
      'Immobiliser ECU Resetting',
      'Opening Service',
      'Repair / Replace Locks',
      'Re-key Existing Locks',
      'We stock a large range of Genuine / Aftermarket keys'
    ]
  };

  const currentBrand = brandData[brand] || defaultData;

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-gray-900 to-black">
      <SEO
        title={`${currentBrand.name} Car Key Replacement - Carkey Solutions Perth`}
        description={`Professional ${currentBrand.name} car key replacement services in Perth. Lost keys, spare keys, immobiliser resetting and more. Call us today!`}
        keywords={`${currentBrand.name} car key replacement perth, ${currentBrand.name} key programming, ${currentBrand.name} locksmith perth`}
      />
      
      {/* Header */}
      <Navigation />

      {/* Main Content */}
      <div className="container-max px-4 py-12">
        <div className="grid lg:grid-cols-2 gap-12">
          {/* Left Column - Content */}
          <div>
            {/* Brand Header */}
            <div className="mb-8">
              <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
                {currentBrand.name} <span className="text-carkey-red">Car Keys</span>
              </h1>
              <p className="text-xl text-gray-300 leading-relaxed">
                {currentBrand.description}
              </p>
            </div>

            {/* Call to Action */}
            <div className="bg-gradient-to-r from-carkey-red to-red-600 rounded-2xl p-6 text-center mb-8">
              <p className="text-white text-lg mb-4">
                Call us today on <strong>+61 430 168 669</strong> for a free quote or fill out our quote form below and one of our friendly staff will be in touch.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <button
                  onClick={() => navigate('/quote', { state: { selectedBrand: currentBrand.name } })}
                  className="bg-black text-white px-8 py-3 rounded-xl font-semibold hover:bg-gray-800 transition-colors"
                >
                  <i className="fas fa-paper-plane mr-2"></i>
                  Get Quote
                </button>
                <a
                  href="tel:+61430168669"
                  className="bg-white text-carkey-red px-8 py-3 rounded-xl font-semibold hover:bg-gray-100 transition-colors"
                >
                  <i className="fas fa-phone mr-2"></i>
                  Call Now
                </a>
              </div>
            </div>

            {/* Features */}
            <div className="space-y-6 mb-8">
              {currentBrand.features.map((feature, index) => (
                <div key={index} className="bg-white/10 backdrop-blur-xl border border-white/20 rounded-2xl p-6">
                  <p className="text-gray-300 leading-relaxed">{feature}</p>
                </div>
              ))}
            </div>


          </div>

          {/* Right Column - Services & Brand */}
          <div>
            {/* Brand Logo */}
            <div className="text-center mb-8">
              <div className="bg-white rounded-2xl p-8 mb-6">
                <img 
                  src={`/tmp/${currentBrand.logo}`} 
                  alt={currentBrand.name} 
                  className="w-32 h-32 mx-auto object-contain"
                />
              </div>
              <h2 className="text-3xl font-bold text-white mb-2">{currentBrand.name.toUpperCase()}</h2>
            </div>

            {/* Services */}
            <div className="bg-white/10 backdrop-blur-xl border border-white/20 rounded-3xl p-8 mb-8">
              <h3 className="text-2xl font-bold text-carkey-red mb-6">What can we offer</h3>
              <ul className="space-y-3">
                {currentBrand.services.map((service, index) => (
                  <li key={index} className="flex items-center text-white">
                    <i className="fas fa-check text-carkey-red mr-3"></i>
                    {service}
                  </li>
                ))}
              </ul>
            </div>

            {/* Trust Badge */}
            <div className="bg-gradient-to-br from-carkey-red to-red-600 text-white rounded-2xl p-6 text-center shadow-xl">
              <div className="text-3xl mb-3">
                <i className="fas fa-shield-alt"></i>
              </div>
              <div className="text-xl font-bold mb-2">Trusted & Reliable</div>
              <div className="text-sm opacity-90 mb-3">Professional Service Guaranteed</div>
              <div className="flex items-center justify-center space-x-1 text-yellow-300">
                <i className="fas fa-star"></i>
                <i className="fas fa-star"></i>
                <i className="fas fa-star"></i>
                <i className="fas fa-star"></i>
                <i className="fas fa-star"></i>
              </div>
              <div className="text-xs mt-2 opacity-80">5-Star Rated Service</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BrandPage;
